export function visitTableConfig(selectDeptClick, selectPersonClick) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: false,
    index: true,
    indexLabel: "序号",
    selection: true,
    selectionWidth: 45,
    labelWidth: 120,
    column: [{
        label: "客户名称",
        prop: "custId",
        type: "select",
        filterable: "true",
        dicUrl: "/api/blade-/zd/custom/basicInformations",
        dicMethod: "post",
        dicQuery: {},
        props: {
          label: "custName",
          value: "id",
        },
        hide: true,
        disabled: true,
        rules: [{
          required: true,
          message: "请输入客户名称",
          trigger: "blur",
        }, ],
      },{
        label: "拜访人员",
        prop: "visitPeopleNames",
        placeholder: "请选择 拜访人员",
        readonly: true,
        hide: true,
        rules: [{
          required: true,
          message: "请选择 拜访人员",
          trigger: "blur",
        }, ],
        click: () => {
          selectPersonClick();
        },
      },{
        label: "拜访部门",
        prop: "visitDeptName",
        placeholder: "请选择 拜访部门",
        readonly: true,
        type: "textarea",
        hide: true,
        span: 12,
        searchClearable: false,
        rules: [{
          required: true,
          message: "请选择 拜访部门",
          trigger: "change",
        }, ],
        click: () => {
          selectDeptClick("visitDept");
        },
      },{
        label: "拜访时间",
        prop: "visitTime",
        type: "datetime",
        rules: [{
          required: true,
          message: "请选择拜访时间",
          trigger: "blur",
        }, ],
        format: "yyyy-MM-dd HH:mm",
        valueFormat: "yyyy-MM-dd HH:mm",
      }, {
        label: "拜访人员",
        prop: "visitPeople",
        type: "select",
        dicUrl: "/api/blade-/zd/custom/users",
        dicMethod: "post",
        width: 120,
        dicQuery: {
          type: 0,
        },
        display: false,
        props: {
          label: "realName",
          value: "id",
        },
        dataType: "string",
      },{
        label: "拜访方式",
        prop: "visitType",
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=visit_type",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: "number",
      },{
        label: "业务类型",
        prop: "visitBusinessType",
        type: "select",
        hide: true,
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=visit_business_type",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        disabled: true,
        searchMultiple: true,
        multiple: true,
      }, {
        label: "拜访原因",
        prop: "visitReason",
        type: "select",
        searchMultiple: true,
        multiple: true,
        hide: true,
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=visit_reason_type",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: "string",
      }, {
        label: '拜访附件',
        prop: 'files',
        formslot:true,
        span: 12,
        hide:true
      },{
        label: "企业对接人",
        prop: "companyUser",
        rules: [{
          required: true,
          message: "请输入企业对接人",
          trigger: "blur",
        }, ]
      }, {
        label: "对接人职务",
        prop: "companyJob",
        rules: [{
          required: true,
          message: "请输入对接人职务",
          trigger: "blur",
        }, ]
      }, {
        label: "对接人手机号",
        prop: "companyMobile",
        rules: [{
          required: true,
          message: "请输入对接人手机号",
          trigger: "blur",
        }, ]
      }
      //  {
      //   label: "拜访原因",
      //   prop: "visitReason",
      //   type: "select",
      //   display: false,
      //   multiple: true,
      //   hide: true,
      //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=visit_reason_type",
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey",
      //   },
      //   dataType: "string",
      // }
    ]
  }
}
